import { atom, useAtom, useSetAtom } from "jotai";

export const postModalAtom = atom(false);
const usePosModal = () => {
  const atom = useAtom(postModalAtom);
  return atom;
};

export const useSetPosModal = () => useSetAtom(postModalAtom);

export default usePosModal;
